import type { JSX } from "react";

import { Flex } from "@mantine/core";

import classes from "./TimelineItem.module.css";

export function TimelineItemWrapperSimplified({
    alignsLeft,
    children,
}: {
    alignsLeft: boolean;
    children: React.ReactNode;
}): JSX.Element {
    return (
        <Flex
            align={alignsLeft ? "flex-start" : "flex-end"}
            className={classes.timelineItemWrapper}
            justify={alignsLeft ? "flex-start" : "flex-end"}
        >
            {children}
        </Flex>
    );
}
